import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  color: #f5f5f5;
  height: 6rem;
  max-height: 10vh;
  background: var(--yellow);

  h1 {
    font-size: 2.5rem;
  }
`